import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../fnx/showError";
export var useRejectionCodesErrorHandling = function (_a) {
    var errorRejectionCodeSets = _a.errorRejectionCodeSets, errorCreateRejectionCodeSet = _a.errorCreateRejectionCodeSet, errorUpdateRejectionCodeSet = _a.errorUpdateRejectionCodeSet, errorDisableRejectionCodeSet = _a.errorDisableRejectionCodeSet, errorDeleteRejectionCodeSet = _a.errorDeleteRejectionCodeSet, onUpdateError = _a.onUpdateError, onDeleteError = _a.onDeleteError, setSeeToast = _a.setSeeToast;
    var t = useTranslation().t;
    useEffect(function () {
        if (errorRejectionCodeSets) {
            showErrorToast(errorRejectionCodeSets, setSeeToast, t);
        }
    }, [errorRejectionCodeSets, setSeeToast, t]);
    useEffect(function () {
        if (errorCreateRejectionCodeSet) {
            showErrorToast(errorCreateRejectionCodeSet, setSeeToast, t);
        }
    }, [errorCreateRejectionCodeSet, setSeeToast, t]);
    useEffect(function () {
        if (errorUpdateRejectionCodeSet) {
            showErrorToast(errorUpdateRejectionCodeSet, setSeeToast, t);
            onUpdateError();
        }
    }, [errorUpdateRejectionCodeSet, setSeeToast, t]);
    useEffect(function () {
        if (errorDisableRejectionCodeSet) {
            showErrorToast(errorDisableRejectionCodeSet, setSeeToast, t);
        }
    }, [errorDisableRejectionCodeSet, setSeeToast, t]);
    useEffect(function () {
        if (errorDeleteRejectionCodeSet) {
            showErrorToast(errorDeleteRejectionCodeSet, setSeeToast, t);
            onDeleteError();
        }
    }, [errorDeleteRejectionCodeSet, setSeeToast, t]);
};
